export default __webpack_public_path__ + "static/media/Marker.ffe6a116.svg";